import { linearish as l } from "./linear.js";
import { initRange as m } from "./init.js";
import { bisectRight as g } from "../../d3-array/src/bisect.js";
function s() {
  var i = 0, u = 1, t = 1, e = [0.5], a = [0, 1], c;
  function r(n) {
    return n != null && n <= n ? a[g(e, n, 0, t)] : c;
  }
  function f() {
    var n = -1;
    for (e = new Array(t); ++n < t; ) e[n] = ((n + 1) * u - (n - t) * i) / (t + 1);
    return r;
  }
  return r.domain = function(n) {
    return arguments.length ? ([i, u] = n, i = +i, u = +u, f()) : [i, u];
  }, r.range = function(n) {
    return arguments.length ? (t = (a = Array.from(n)).length - 1, f()) : a.slice();
  }, r.invertExtent = function(n) {
    var o = a.indexOf(n);
    return o < 0 ? [NaN, NaN] : o < 1 ? [i, e[0]] : o >= t ? [e[t - 1], u] : [e[o - 1], e[o]];
  }, r.unknown = function(n) {
    return arguments.length && (c = n), r;
  }, r.thresholds = function() {
    return e.slice();
  }, r.copy = function() {
    return s().domain([i, u]).range(a).unknown(c);
  }, m.apply(l(r), arguments);
}
export {
  s as default
};
